import { Button, Card, CardHeader, Col, Grid, PageLoader, Row, Table } from '@met/react-components';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { toastr } from 'react-redux-toastr';
import { adminActions } from '../../store';
import AddAdyenLocationModal from './AddAdyenLocationModal';

const AdyenSettings = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isAddLocationOpen, setIsAddLocationOpen] = useState(false);
  const { data: locations, isLoading, isError } = useSelector(state => state.admin.adminLocations);

  useEffect(() => {
    dispatch(adminActions.listAdminLocations()).catch(() => {
      toastr.error('Error: Adyen settings', 'Could not load locations.');
    });
  }, [dispatch]);

  const handleLocationCreated = locationId => {
    setIsAddLocationOpen(false);
    toastr.success('Location added', `Adyen settings created for ${locationId}.`);
    history.push(`/Admin/AdyenSettings/${encodeURIComponent(locationId)}`);
  };

  const columns = {
    locationId: { label: 'Location' },
    provider: { label: 'Provider' },
    adyenMerchantAccount: { label: 'Merchant Account' },
    adyenPosMerchantAccount: { label: 'POS Merchant Account' },
    adyenStoreId: { label: 'Store ID' },
    adyenCurrencyCode: { label: 'Currency' },
    actions: {
      label: '',
      content: item => (
        <Button
          icon='edit'
          title={`Edit ${item.locationId}`}
          onClick={() => history.push(`/Admin/AdyenSettings/${encodeURIComponent(item.locationId)}`)}
        />
      )
    }
  };

  return (
    <Grid fluid>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              Adyen Settings by Location
              <Button
                icon='plus'
                title='Add location'
                onClick={() => setIsAddLocationOpen(true)}
                style={{ marginLeft: 'auto' }}
              />
            </CardHeader>
            {isLoading && <PageLoader />}
            {!isLoading && isError && <p role='alert'>Could not load locations. Refresh to try again.</p>}
            {!isLoading && !isError && locations.length === 0 && <p>No locations found.</p>}
            {!isLoading && !isError && locations.length > 0 && (
              <Table columns={columns} data={locations} />
            )}
          </Card>
        </Col>
      </Row>
      <AddAdyenLocationModal
        isOpen={isAddLocationOpen}
        onClose={() => setIsAddLocationOpen(false)}
        onCreated={handleLocationCreated}
      />
    </Grid>
  );
};

export default AdyenSettings;